import React, { useEffect, useState } from 'react';
import { X, ShoppingBag, Star, TrendingUp, Truck } from 'lucide-react';
export function LiveOrderPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState({
    text: '',
    icon: ShoppingBag
  });
  const messages = [{
    text: 'Someone just ordered the 3x Dentafix™ bundle',
    icon: ShoppingBag
  }, {
    text: 'Dentafix™ is trending — 47 orders today',
    icon: TrendingUp
  }, {
    text: 'A customer just secured their discount bundle',
    icon: Star
  }, {
    text: 'Another Dentafix™ order is being shipped',
    icon: Truck
  }];
  useEffect(() => {
    const showPopup = () => {
      const randomMsg = messages[Math.floor(Math.random() * messages.length)];
      setMessage(randomMsg);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-24 left-4 md:bottom-8 md:left-8 z-40 max-w-xs w-full animate-in slide-in-from-left duration-500 fade-in" data-id="element-240">
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-start gap-3 relative" data-id="element-241">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-242">
          <X className="w-3 h-3" data-id="element-243" />
        </button>

        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-244">
          <message.icon className="w-5 h-5 text-green-600" data-id="element-245" />
        </div>

        <div data-id="element-246">
          <p className="font-bold text-gray-900 text-sm" data-id="element-247">Just Now</p>
          <p className="text-sm text-gray-600 leading-tight" data-id="element-248">{message.text}</p>
        </div>
      </div>
    </div>;
}